import React from "react";
import About1 from "./About1";
import CorporateProfile from "./CorporateProfile";
import CorporateObjectives from "./CoporateObjective";
import StaffCarousel from "./StaffsCarousel";
import CorporateTeam from "./CoporateTeam";

const AboutPage = ()=>{
    return(
        <div>
            <About1/>
            <CorporateProfile/>
            <CorporateObjectives/>
          
            <StaffCarousel/>
              <CorporateTeam/>
        </div>
    )
}

export default AboutPage